import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useRealmApp } from "../RealmApp";
import { useDatesContext } from "context/DatesContext";

const useClockIns = (storeId, start, end) => {
  const app = useRealmApp();
  const { clockIns, loading } = useAllClockIns(
    app.currentUser.id,
    storeId,
    start,
    end
  );
  return {
    loading,
    clockIns,
  };
};

export const useSessionClockIns = (sessionId) => {
  const app = useRealmApp();
  const { clockIns, loading } = useAllSessionClockIns(
    app.currentUser.id,
    sessionId
  );
  return {
    loading,
    clockIns,
  };
};

export default useClockIns;

function useAllClockIns(ownerId, storeId, start, end) {
  const variables = {
    storeId,
    start,
    end,
  };

  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllClockIns", 60 * 1000);

  const { data, loading, error } = useQuery(
    gql`
      query getClockIns(
        $storeId: ObjectId!
        $start: DateTime!
        $end: DateTime!
      ) {
        clockIns(
          query: {
            storeId: $storeId
            clockDatetime_gt: $start
            clockDatetime_lte: $end
          }
          limit: 0
        ) {
          _id
          sessionId
          chainSessionId
          storeId
          userId
          type
          geolocation
          faceId
          notes
          updated
          clockDatetime
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables, fetchPolicy }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list

  const clockIns = data?.clockIns ?? [];
  return { clockIns, loading };
}

function useAllSessionClockIns(ownerId, sessionId) {
  const { data, loading, error } = useQuery(
    gql`
      query getClockIns($sessionId: ObjectId!) {
        clockIns(
          query: {
            OR: [{ sessionId: $sessionId }, { chainSessionId: $sessionId }]
          }
          limit: 5
        ) {
          _id
          sessionId
          chainSessionId
          storeId
          userId
          type
          geolocation
          faceId
          notes
          updated
          clockDatetime
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { sessionId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list

  const clockIns = data?.clockIns ?? [];
  return { clockIns, loading };
}
